'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrenchIcon = exports.VideoIcon = exports.VectorDifferenceIcon = exports.VectorDifferenceBaIcon = exports.VectorDifferenceAbIcon = exports.UploadIcon = exports.UploadFileIcon = undefined;
exports.UnlockIcon = exports.TwitterIcon = exports.TrashIcon = exports.TooltipTextIcon = exports.TooltipIcon = exports.ThumnailViewIcon = exports.ThemeIcon = exports.TeamIcon = exports.TalkChatMultipleIcon = exports.TalkChatIcon = exports.TagOutlineIcon = exports.TagIcon = exports.SuitcaseIcon = exports.StarIcon = exports.SquareIcon = exports.SignOutIcon = exports.ShareVariantIcon = exports.ShareIcon = exports.SearchIcon = exports.SaveIcon = exports.RotateRightIcon = exports.RotateLeftIcon = exports.RevisionsIcon = exports.ResizeUpIcon = exports.ResizeDownIcon = exports.ReorderVerticalIcon = exports.ReorderHorizontalIcon = exports.RefreshIcon = exports.RecentIcon = exports.QuestionIcon = exports.PlusIcon = exports.PlotTableIcon = exports.PlayIcon = exports.PhoneIcon = exports.OfficeIcon = exports.MinusIcon = exports.LockIcon = exports.ListViewIcon = exports.LinkVariantIcon = exports.LinkIcon = exports.LinkedInIcon = exports.InstagramIcon = exports.InboxIcon = exports.InboxArrowIcon = exports.ImportIcon = exports.HeartIcon = exports.GridIcon = exports.GraphIcon = exports.GooglePlusIcon = exports.GlobeIcon = exports.GitHubIcon = exports.FullViewIcon = exports.FormatAlignRightIcon = exports.FormatAlignLeftIcon = exports.FormatAlignCenterIcon = exports.FolderOpenIcon = exports.FolderIcon = exports.FlipToFrontIcon = exports.FlipToBackIcon = exports.FilterIcon = exports.FileMultipleIcon = exports.FileIcon = exports.FileDocumentIcon = exports.FacebookIcon = exports.ExternalLinkIcon = exports.EnvelopeOutlineIcon = exports.EnvelopeIcon = exports.EditIcon = exports.DownloadIcon = exports.CreditCardIcon = exports.ContentCopyIcon = exports.CollageIcon = exports.CollaboratorIcon = exports.CogIcon = exports.CodeBracesIcon = exports.CloudIcon = exports.CloseIcon = exports.CheckIcon = exports.CheckboxMarkedOutlineIcon = exports.ChatOutlineIcon = exports.ChatIcon = exports.ChartLineIcon = exports.CarretUpIcon = exports.CarretDownIcon = exports.CalendarMultiselectIcon = exports.BufferIcon = exports.BookmarkIcon = exports.BellIcon = exports.BarsIcon = exports.ArrowUpIcon = exports.ArrowRightIcon = exports.ArrowLeftIcon = exports.ArrowDownIcon = exports.ArrangeSendBackwardIcon = exports.AnimationIcon = exports.AngleUpIcon = exports.AngleRightIcon = exports.AngleLeftIcon = exports.AngleDownIcon = exports.AccountIcon = undefined;

var _components = require('./components');

Object.keys(_components).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _components[key];
    }
  });
});

var _AccountIcon = require('mdi-react/AccountIcon');

var _AccountIcon2 = _interopRequireDefault(_AccountIcon);

var _ChevronDownIcon = require('mdi-react/ChevronDownIcon');

var _ChevronDownIcon2 = _interopRequireDefault(_ChevronDownIcon);

var _ChevronLeftIcon = require('mdi-react/ChevronLeftIcon');

var _ChevronLeftIcon2 = _interopRequireDefault(_ChevronLeftIcon);

var _ChevronRightIcon = require('mdi-react/ChevronRightIcon');

var _ChevronRightIcon2 = _interopRequireDefault(_ChevronRightIcon);

var _ChevronUpIcon = require('mdi-react/ChevronUpIcon');

var _ChevronUpIcon2 = _interopRequireDefault(_ChevronUpIcon);

var _AnimationIcon = require('mdi-react/AnimationIcon');

var _AnimationIcon2 = _interopRequireDefault(_AnimationIcon);

var _ArrangeSendBackwardIcon = require('mdi-react/ArrangeSendBackwardIcon');

var _ArrangeSendBackwardIcon2 = _interopRequireDefault(_ArrangeSendBackwardIcon);

var _ArrowDownIcon = require('mdi-react/ArrowDownIcon');

var _ArrowDownIcon2 = _interopRequireDefault(_ArrowDownIcon);

var _ArrowLeftIcon = require('mdi-react/ArrowLeftIcon');

var _ArrowLeftIcon2 = _interopRequireDefault(_ArrowLeftIcon);

var _ArrowRightIcon = require('mdi-react/ArrowRightIcon');

var _ArrowRightIcon2 = _interopRequireDefault(_ArrowRightIcon);

var _ArrowUpIcon = require('mdi-react/ArrowUpIcon');

var _ArrowUpIcon2 = _interopRequireDefault(_ArrowUpIcon);

var _MenuIcon = require('mdi-react/MenuIcon');

var _MenuIcon2 = _interopRequireDefault(_MenuIcon);

var _BellIcon = require('mdi-react/BellIcon');

var _BellIcon2 = _interopRequireDefault(_BellIcon);

var _BookmarkIcon = require('mdi-react/BookmarkIcon');

var _BookmarkIcon2 = _interopRequireDefault(_BookmarkIcon);

var _BufferIcon = require('mdi-react/BufferIcon');

var _BufferIcon2 = _interopRequireDefault(_BufferIcon);

var _CalendarMultiselectIcon = require('mdi-react/CalendarMultiselectIcon');

var _CalendarMultiselectIcon2 = _interopRequireDefault(_CalendarMultiselectIcon);

var _MenuDownIcon = require('mdi-react/MenuDownIcon');

var _MenuDownIcon2 = _interopRequireDefault(_MenuDownIcon);

var _MenuUpIcon = require('mdi-react/MenuUpIcon');

var _MenuUpIcon2 = _interopRequireDefault(_MenuUpIcon);

var _ChartLineIcon = require('mdi-react/ChartLineIcon');

var _ChartLineIcon2 = _interopRequireDefault(_ChartLineIcon);

var _MessageIcon = require('mdi-react/MessageIcon');

var _MessageIcon2 = _interopRequireDefault(_MessageIcon);

var _MessageOutlineIcon = require('mdi-react/MessageOutlineIcon');

var _MessageOutlineIcon2 = _interopRequireDefault(_MessageOutlineIcon);

var _CheckboxMarkedOutlineIcon = require('mdi-react/CheckboxMarkedOutlineIcon');

var _CheckboxMarkedOutlineIcon2 = _interopRequireDefault(_CheckboxMarkedOutlineIcon);

var _CheckIcon = require('mdi-react/CheckIcon');

var _CheckIcon2 = _interopRequireDefault(_CheckIcon);

var _CloseIcon = require('mdi-react/CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _CloudIcon = require('mdi-react/CloudIcon');

var _CloudIcon2 = _interopRequireDefault(_CloudIcon);

var _CodeBracesIcon = require('mdi-react/CodeBracesIcon');

var _CodeBracesIcon2 = _interopRequireDefault(_CodeBracesIcon);

var _SettingsIcon = require('mdi-react/SettingsIcon');

var _SettingsIcon2 = _interopRequireDefault(_SettingsIcon);

var _AccountMultipleIcon = require('mdi-react/AccountMultipleIcon');

var _AccountMultipleIcon2 = _interopRequireDefault(_AccountMultipleIcon);

var _CollageIcon = require('mdi-react/CollageIcon');

var _CollageIcon2 = _interopRequireDefault(_CollageIcon);

var _ContentCopyIcon = require('mdi-react/ContentCopyIcon');

var _ContentCopyIcon2 = _interopRequireDefault(_ContentCopyIcon);

var _CreditCardIcon = require('mdi-react/CreditCardIcon');

var _CreditCardIcon2 = _interopRequireDefault(_CreditCardIcon);

var _DownloadIcon = require('mdi-react/DownloadIcon');

var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);

var _PencilIcon = require('mdi-react/PencilIcon');

var _PencilIcon2 = _interopRequireDefault(_PencilIcon);

var _EmailIcon = require('mdi-react/EmailIcon');

var _EmailIcon2 = _interopRequireDefault(_EmailIcon);

var _EmailOutlineIcon = require('mdi-react/EmailOutlineIcon');

var _EmailOutlineIcon2 = _interopRequireDefault(_EmailOutlineIcon);

var _OpenInNewIcon = require('mdi-react/OpenInNewIcon');

var _OpenInNewIcon2 = _interopRequireDefault(_OpenInNewIcon);

var _FacebookBoxIcon = require('mdi-react/FacebookBoxIcon');

var _FacebookBoxIcon2 = _interopRequireDefault(_FacebookBoxIcon);

var _FileDocumentIcon = require('mdi-react/FileDocumentIcon');

var _FileDocumentIcon2 = _interopRequireDefault(_FileDocumentIcon);

var _FileIcon = require('mdi-react/FileIcon');

var _FileIcon2 = _interopRequireDefault(_FileIcon);

var _FileMultipleIcon = require('mdi-react/FileMultipleIcon');

var _FileMultipleIcon2 = _interopRequireDefault(_FileMultipleIcon);

var _FilterIcon = require('mdi-react/FilterIcon');

var _FilterIcon2 = _interopRequireDefault(_FilterIcon);

var _FlipToBackIcon = require('mdi-react/FlipToBackIcon');

var _FlipToBackIcon2 = _interopRequireDefault(_FlipToBackIcon);

var _FlipToFrontIcon = require('mdi-react/FlipToFrontIcon');

var _FlipToFrontIcon2 = _interopRequireDefault(_FlipToFrontIcon);

var _FolderIcon = require('mdi-react/FolderIcon');

var _FolderIcon2 = _interopRequireDefault(_FolderIcon);

var _FolderOpenIcon = require('mdi-react/FolderOpenIcon');

var _FolderOpenIcon2 = _interopRequireDefault(_FolderOpenIcon);

var _FormatAlignCenterIcon = require('mdi-react/FormatAlignCenterIcon');

var _FormatAlignCenterIcon2 = _interopRequireDefault(_FormatAlignCenterIcon);

var _FormatAlignLeftIcon = require('mdi-react/FormatAlignLeftIcon');

var _FormatAlignLeftIcon2 = _interopRequireDefault(_FormatAlignLeftIcon);

var _FormatAlignRightIcon = require('mdi-react/FormatAlignRightIcon');

var _FormatAlignRightIcon2 = _interopRequireDefault(_FormatAlignRightIcon);

var _FullscreenIcon = require('mdi-react/FullscreenIcon');

var _FullscreenIcon2 = _interopRequireDefault(_FullscreenIcon);

var _GithubCircleIcon = require('mdi-react/GithubCircleIcon');

var _GithubCircleIcon2 = _interopRequireDefault(_GithubCircleIcon);

var _EarthIcon = require('mdi-react/EarthIcon');

var _EarthIcon2 = _interopRequireDefault(_EarthIcon);

var _GooglePlusIcon = require('mdi-react/GooglePlusIcon');

var _GooglePlusIcon2 = _interopRequireDefault(_GooglePlusIcon);

var _PollIcon = require('mdi-react/PollIcon');

var _PollIcon2 = _interopRequireDefault(_PollIcon);

var _GridIcon = require('mdi-react/GridIcon');

var _GridIcon2 = _interopRequireDefault(_GridIcon);

var _HeartIcon = require('mdi-react/HeartIcon');

var _HeartIcon2 = _interopRequireDefault(_HeartIcon);

var _ImportIcon = require('mdi-react/ImportIcon');

var _ImportIcon2 = _interopRequireDefault(_ImportIcon);

var _InboxArrowDownIcon = require('mdi-react/InboxArrowDownIcon');

var _InboxArrowDownIcon2 = _interopRequireDefault(_InboxArrowDownIcon);

var _InboxIcon = require('mdi-react/InboxIcon');

var _InboxIcon2 = _interopRequireDefault(_InboxIcon);

var _InstagramIcon = require('mdi-react/InstagramIcon');

var _InstagramIcon2 = _interopRequireDefault(_InstagramIcon);

var _LinkedinBoxIcon = require('mdi-react/LinkedinBoxIcon');

var _LinkedinBoxIcon2 = _interopRequireDefault(_LinkedinBoxIcon);

var _LinkVariantIcon = require('mdi-react/LinkVariantIcon');

var _LinkVariantIcon2 = _interopRequireDefault(_LinkVariantIcon);

var _ViewListIcon = require('mdi-react/ViewListIcon');

var _ViewListIcon2 = _interopRequireDefault(_ViewListIcon);

var _LockIcon = require('mdi-react/LockIcon');

var _LockIcon2 = _interopRequireDefault(_LockIcon);

var _MinusIcon = require('mdi-react/MinusIcon');

var _MinusIcon2 = _interopRequireDefault(_MinusIcon);

var _DomainIcon = require('mdi-react/DomainIcon');

var _DomainIcon2 = _interopRequireDefault(_DomainIcon);

var _PhoneIcon = require('mdi-react/PhoneIcon');

var _PhoneIcon2 = _interopRequireDefault(_PhoneIcon);

var _PlayIcon = require('mdi-react/PlayIcon');

var _PlayIcon2 = _interopRequireDefault(_PlayIcon);

var _TableIcon = require('mdi-react/TableIcon');

var _TableIcon2 = _interopRequireDefault(_TableIcon);

var _PlusIcon = require('mdi-react/PlusIcon');

var _PlusIcon2 = _interopRequireDefault(_PlusIcon);

var _HelpCircleIcon = require('mdi-react/HelpCircleIcon');

var _HelpCircleIcon2 = _interopRequireDefault(_HelpCircleIcon);

var _ClockIcon = require('mdi-react/ClockIcon');

var _ClockIcon2 = _interopRequireDefault(_ClockIcon);

var _RefreshIcon = require('mdi-react/RefreshIcon');

var _RefreshIcon2 = _interopRequireDefault(_RefreshIcon);

var _ReorderHorizontalIcon = require('mdi-react/ReorderHorizontalIcon');

var _ReorderHorizontalIcon2 = _interopRequireDefault(_ReorderHorizontalIcon);

var _ReorderVerticalIcon = require('mdi-react/ReorderVerticalIcon');

var _ReorderVerticalIcon2 = _interopRequireDefault(_ReorderVerticalIcon);

var _ArrowCollapseIcon = require('mdi-react/ArrowCollapseIcon');

var _ArrowCollapseIcon2 = _interopRequireDefault(_ArrowCollapseIcon);

var _ArrowExpandIcon = require('mdi-react/ArrowExpandIcon');

var _ArrowExpandIcon2 = _interopRequireDefault(_ArrowExpandIcon);

var _HistoryIcon = require('mdi-react/HistoryIcon');

var _HistoryIcon2 = _interopRequireDefault(_HistoryIcon);

var _RotateLeftIcon = require('mdi-react/RotateLeftIcon');

var _RotateLeftIcon2 = _interopRequireDefault(_RotateLeftIcon);

var _RotateRightIcon = require('mdi-react/RotateRightIcon');

var _RotateRightIcon2 = _interopRequireDefault(_RotateRightIcon);

var _ContentSaveIcon = require('mdi-react/ContentSaveIcon');

var _ContentSaveIcon2 = _interopRequireDefault(_ContentSaveIcon);

var _MagnifyIcon = require('mdi-react/MagnifyIcon');

var _MagnifyIcon2 = _interopRequireDefault(_MagnifyIcon);

var _ShareIcon = require('mdi-react/ShareIcon');

var _ShareIcon2 = _interopRequireDefault(_ShareIcon);

var _ShareVariantIcon = require('mdi-react/ShareVariantIcon');

var _ShareVariantIcon2 = _interopRequireDefault(_ShareVariantIcon);

var _LogoutIcon = require('mdi-react/LogoutIcon');

var _LogoutIcon2 = _interopRequireDefault(_LogoutIcon);

var _CropSquareIcon = require('mdi-react/CropSquareIcon');

var _CropSquareIcon2 = _interopRequireDefault(_CropSquareIcon);

var _StarIcon = require('mdi-react/StarIcon');

var _StarIcon2 = _interopRequireDefault(_StarIcon);

var _BriefcaseIcon = require('mdi-react/BriefcaseIcon');

var _BriefcaseIcon2 = _interopRequireDefault(_BriefcaseIcon);

var _TagIcon = require('mdi-react/TagIcon');

var _TagIcon2 = _interopRequireDefault(_TagIcon);

var _TagOutlineIcon = require('mdi-react/TagOutlineIcon');

var _TagOutlineIcon2 = _interopRequireDefault(_TagOutlineIcon);

var _ForumIcon = require('mdi-react/ForumIcon');

var _ForumIcon2 = _interopRequireDefault(_ForumIcon);

var _AccountMultipleOutlineIcon = require('mdi-react/AccountMultipleOutlineIcon');

var _AccountMultipleOutlineIcon2 = _interopRequireDefault(_AccountMultipleOutlineIcon);

var _FormatPaintIcon = require('mdi-react/FormatPaintIcon');

var _FormatPaintIcon2 = _interopRequireDefault(_FormatPaintIcon);

var _AppsIcon = require('mdi-react/AppsIcon');

var _AppsIcon2 = _interopRequireDefault(_AppsIcon);

var _TooltipIcon = require('mdi-react/TooltipIcon');

var _TooltipIcon2 = _interopRequireDefault(_TooltipIcon);

var _TooltipTextIcon = require('mdi-react/TooltipTextIcon');

var _TooltipTextIcon2 = _interopRequireDefault(_TooltipTextIcon);

var _DeleteIcon = require('mdi-react/DeleteIcon');

var _DeleteIcon2 = _interopRequireDefault(_DeleteIcon);

var _TwitterIcon = require('mdi-react/TwitterIcon');

var _TwitterIcon2 = _interopRequireDefault(_TwitterIcon);

var _LockOpenIcon = require('mdi-react/LockOpenIcon');

var _LockOpenIcon2 = _interopRequireDefault(_LockOpenIcon);

var _FileExportIcon = require('mdi-react/FileExportIcon');

var _FileExportIcon2 = _interopRequireDefault(_FileExportIcon);

var _UploadIcon = require('mdi-react/UploadIcon');

var _UploadIcon2 = _interopRequireDefault(_UploadIcon);

var _VectorDifferenceAbIcon = require('mdi-react/VectorDifferenceAbIcon');

var _VectorDifferenceAbIcon2 = _interopRequireDefault(_VectorDifferenceAbIcon);

var _VectorDifferenceBaIcon = require('mdi-react/VectorDifferenceBaIcon');

var _VectorDifferenceBaIcon2 = _interopRequireDefault(_VectorDifferenceBaIcon);

var _VectorDifferenceIcon = require('mdi-react/VectorDifferenceIcon');

var _VectorDifferenceIcon2 = _interopRequireDefault(_VectorDifferenceIcon);

var _VideoIcon = require('mdi-react/VideoIcon');

var _VideoIcon2 = _interopRequireDefault(_VideoIcon);

var _WrenchIcon = require('mdi-react/WrenchIcon');

var _WrenchIcon2 = _interopRequireDefault(_WrenchIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Material Design Icons
exports.AccountIcon = _AccountIcon2.default;
exports.AngleDownIcon = _ChevronDownIcon2.default;
exports.AngleLeftIcon = _ChevronLeftIcon2.default;
exports.AngleRightIcon = _ChevronRightIcon2.default;
exports.AngleUpIcon = _ChevronUpIcon2.default;
exports.AnimationIcon = _AnimationIcon2.default;
exports.ArrangeSendBackwardIcon = _ArrangeSendBackwardIcon2.default;
exports.ArrowDownIcon = _ArrowDownIcon2.default;
exports.ArrowLeftIcon = _ArrowLeftIcon2.default;
exports.ArrowRightIcon = _ArrowRightIcon2.default;
exports.ArrowUpIcon = _ArrowUpIcon2.default;
exports.BarsIcon = _MenuIcon2.default;
exports.BellIcon = _BellIcon2.default;
exports.BookmarkIcon = _BookmarkIcon2.default;
exports.BufferIcon = _BufferIcon2.default;
exports.CalendarMultiselectIcon = _CalendarMultiselectIcon2.default;
exports.CarretDownIcon = _MenuDownIcon2.default;
exports.CarretUpIcon = _MenuUpIcon2.default;
exports.ChartLineIcon = _ChartLineIcon2.default;
exports.ChatIcon = _MessageIcon2.default;
exports.ChatOutlineIcon = _MessageOutlineIcon2.default;
exports.CheckboxMarkedOutlineIcon = _CheckboxMarkedOutlineIcon2.default;
exports.CheckIcon = _CheckIcon2.default;
exports.CloseIcon = _CloseIcon2.default;
exports.CloudIcon = _CloudIcon2.default;
exports.CodeBracesIcon = _CodeBracesIcon2.default;
exports.CogIcon = _SettingsIcon2.default;
exports.CollaboratorIcon = _AccountMultipleIcon2.default;
exports.CollageIcon = _CollageIcon2.default;
exports.ContentCopyIcon = _ContentCopyIcon2.default;
exports.CreditCardIcon = _CreditCardIcon2.default;
exports.DownloadIcon = _DownloadIcon2.default;
exports.EditIcon = _PencilIcon2.default;
exports.EnvelopeIcon = _EmailIcon2.default;
exports.EnvelopeOutlineIcon = _EmailOutlineIcon2.default;
exports.ExternalLinkIcon = _OpenInNewIcon2.default;
exports.FacebookIcon = _FacebookBoxIcon2.default;
exports.FileDocumentIcon = _FileDocumentIcon2.default;
exports.FileIcon = _FileIcon2.default;
exports.FileMultipleIcon = _FileMultipleIcon2.default;
exports.FilterIcon = _FilterIcon2.default;
exports.FlipToBackIcon = _FlipToBackIcon2.default;
exports.FlipToFrontIcon = _FlipToFrontIcon2.default;
exports.FolderIcon = _FolderIcon2.default;
exports.FolderOpenIcon = _FolderOpenIcon2.default;
exports.FormatAlignCenterIcon = _FormatAlignCenterIcon2.default;
exports.FormatAlignLeftIcon = _FormatAlignLeftIcon2.default;
exports.FormatAlignRightIcon = _FormatAlignRightIcon2.default;
exports.FullViewIcon = _FullscreenIcon2.default;
exports.GitHubIcon = _GithubCircleIcon2.default;
exports.GlobeIcon = _EarthIcon2.default;
exports.GooglePlusIcon = _GooglePlusIcon2.default;
exports.GraphIcon = _PollIcon2.default;
exports.GridIcon = _GridIcon2.default;
exports.HeartIcon = _HeartIcon2.default;
exports.ImportIcon = _ImportIcon2.default;
exports.InboxArrowIcon = _InboxArrowDownIcon2.default;
exports.InboxIcon = _InboxIcon2.default;
exports.InstagramIcon = _InstagramIcon2.default;
exports.LinkedInIcon = _LinkedinBoxIcon2.default;
exports.LinkIcon = _LinkVariantIcon2.default;
exports.LinkVariantIcon = _LinkVariantIcon2.default;
exports.ListViewIcon = _ViewListIcon2.default;
exports.LockIcon = _LockIcon2.default;
exports.MinusIcon = _MinusIcon2.default;
exports.OfficeIcon = _DomainIcon2.default;
exports.PhoneIcon = _PhoneIcon2.default;
exports.PlayIcon = _PlayIcon2.default;
exports.PlotTableIcon = _TableIcon2.default;
exports.PlusIcon = _PlusIcon2.default;
exports.QuestionIcon = _HelpCircleIcon2.default;
exports.RecentIcon = _ClockIcon2.default;
exports.RefreshIcon = _RefreshIcon2.default;
exports.ReorderHorizontalIcon = _ReorderHorizontalIcon2.default;
exports.ReorderVerticalIcon = _ReorderVerticalIcon2.default;
exports.ResizeDownIcon = _ArrowCollapseIcon2.default;
exports.ResizeUpIcon = _ArrowExpandIcon2.default;
exports.RevisionsIcon = _HistoryIcon2.default;
exports.RotateLeftIcon = _RotateLeftIcon2.default;
exports.RotateRightIcon = _RotateRightIcon2.default;
exports.SaveIcon = _ContentSaveIcon2.default;
exports.SearchIcon = _MagnifyIcon2.default;
exports.ShareIcon = _ShareIcon2.default;
exports.ShareVariantIcon = _ShareVariantIcon2.default;
exports.SignOutIcon = _LogoutIcon2.default;
exports.SquareIcon = _CropSquareIcon2.default;
exports.StarIcon = _StarIcon2.default;
exports.SuitcaseIcon = _BriefcaseIcon2.default;
exports.TagIcon = _TagIcon2.default;
exports.TagOutlineIcon = _TagOutlineIcon2.default;
exports.TalkChatIcon = _MessageIcon2.default;
exports.TalkChatMultipleIcon = _ForumIcon2.default;
exports.TeamIcon = _AccountMultipleOutlineIcon2.default;
exports.ThemeIcon = _FormatPaintIcon2.default;
exports.ThumnailViewIcon = _AppsIcon2.default;
exports.TooltipIcon = _TooltipIcon2.default;
exports.TooltipTextIcon = _TooltipTextIcon2.default;
exports.TrashIcon = _DeleteIcon2.default;
exports.TwitterIcon = _TwitterIcon2.default;
exports.UnlockIcon = _LockOpenIcon2.default;
exports.UploadFileIcon = _FileExportIcon2.default;
exports.UploadIcon = _UploadIcon2.default;
exports.VectorDifferenceAbIcon = _VectorDifferenceAbIcon2.default;
exports.VectorDifferenceBaIcon = _VectorDifferenceBaIcon2.default;
exports.VectorDifferenceIcon = _VectorDifferenceIcon2.default;
exports.VideoIcon = _VideoIcon2.default;
exports.WrenchIcon = _WrenchIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/index.js
// module id = 13
// module chunks = 0